if(document.getElementById('scroll-down')) {
    document.getElementById('scroll-down').addEventListener('click', function(e){
        //alert('blorp');
        window.scrollTo({
            top: window.innerHeight,
            behavior: 'smooth'
        });
        e.preventDefault();
    });
}
const tabs = document.querySelectorAll('.movie-display > .tabs-container > .tab');
const videoIframe = document.querySelector('.vidwrap iframe');

if(tabs){
    tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => {

          tabs.forEach(tab => tab.classList.remove('active'));

          tab.classList.add('active');

          if (index === 0) {
            videoIframe.src = "https://player.vimeo.com/video/910412790?&autoplay=1";
          } else if (index === 1) {
            videoIframe.src = "https://player.vimeo.com/video/910414430?h=3b2823c751&autoplay=1";
          }
        });
      });
}